const ScholarshipFinalCtaSection = () => {
  return (
    <section className="w-full bg-primary text-white py-14 lg:py-20 px-6 lg:px-8">
      <div className="container mx-auto flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 lg:gap-[70px]">
        <div>
          <p className="flex items-center gap-3 text-secondary font-poppins text-sm font-extrabold tracking-widest uppercase mb-5">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            Your Next Step
          </p>
          <h2
            className="max-w-[900px] font-poppins font-bold tracking-[-0.045em] m-0 mb-3.5"
            style={{ fontSize: "clamp(30px, 4vw, 52px)", lineHeight: 1.14 }}
          >
            Open the door. Then help talent walk through it.
          </h2>
          <p className="max-w-[760px] text-[#d7dfff] font-poppins text-[17px] leading-[1.72] m-0">
            Create or discover a scholarship pathway connected to practical
            learning and career progress.
          </p>
        </div>

        <a
          href="mailto:admissions@utiva.co?subject=Current%20Utiva%20Scholarships"
          className="w-full lg:w-auto flex-none text-primary bg-secondary font-poppins min-h-[54px] px-[22px] py-[14px] rounded-xl inline-flex items-center justify-center gap-[11px] font-bold text-[15px] hover:bg-[#ffc342] transition-colors focus:outline-none"
        >
          Ask about scholarships
          <span aria-hidden="true">↗</span>
        </a>
      </div>
    </section>
  );
};

export default ScholarshipFinalCtaSection;
